import React, { useEffect, useState,useRef } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate,useLocation, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import classes from "../css/SubscribePage.module.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Lottie from "lottie-react";
import loaderAnimation from "../animations/loader.json";
import axios from "axios";
import { otpAfterDecline, otp as verifyOtpEndpoint } from "../api/api"; 

import {
  baseUrl,
  subscribe as qualifyEndpoint, // POST /api/v1/qualify
  checkFlow,
  baseUrlApi,
  getscriptflow, // POST /api/v1/check-flow?ext_ref=
} from "../api/api";
import BlockModal from "../components/BlockModal";
import BlockModalFree from "../components/BlockModalFree";

const SubscribePageFree = () => {
  const [loading, setLoading] = useState(false);
  const [msisdn, setMsisdn] = useState(null);
  const [extRef, setExtRef] = useState("");
  const [flowType, setFlowType] = useState("loading"); // "mobile" | "wifi" | "loading"
  const navigate = useNavigate();
    const [sourceTrxId,setSourceTrxId] = useState(null)
    const [packageId,setPackageId] = useState('')

    const [otpPage,setOtpPage] = useState(false)
  const [redirecting, setRedirecting] = useState(false);

const [contentBlockStatus,setContentBlockStatus] = useState(null)
      const [contentBlockDecision,setContentBlockDecision] = useState('Accepted')


  const [otp, setOtp] = useState("");
    const inputsRef = useRef([]);
    const [TVal, setTVal] = useState("");
    const [verifying, setVerifying] = useState(false);
    const [showResend,setShowResend] = useState(false)

    const [showBlockModal,setShowBlockModal] = useState(false)
        // const [showBlockModal,setShowBlockModal] = useState(true)


      const Params = new URLSearchParams(window.location.search)
  const ext_ref = Params.get('ext_ref')



    const location = useLocation();
  const previousRoute = useRef(null);

  useEffect(() => {
    previousRoute.current = location.pathname;
    
  }, [location.pathname]);



 


  console.log(previousRoute)


const uniqueIdRef = useRef(uuidv4());
    const getScript = async () => {
    // setLoading(true);
  
    try {
      const url = `${baseUrlApi}${getscriptflow}?txnId=${ext_ref || uniqueIdRef.current}`;
      const { data } = await axios.get(url);  
      console.log(data,'---data---')
     
  
      const parsed = JSON.parse(data.response); 
      const scriptContent = parsed.s;
      const t = parsed.t;
      const ti = data.ti;
  
      console.log(t,'--t----');
      console.log(ti,'=======ti=======');
      console.log(scriptContent,'=====sc======')
  
      //  keep them for the backend wherever you like
      // sessionStorage.setItem("antiScript", scriptContent);
      // sessionStorage.setItem("antiToken", t);
      // sessionStorage.setItem("antiTxnId", ti);
  
      // also in state if you still need them here
      setTVal(t);
      setExtRef(ti);
  
      //  inject the returned anti‑fraud script (unchanged)
      if (scriptContent) {
        const top_head = document.head;
        const anti_script = document.createElement("script");
        anti_script.innerHTML = scriptContent;
        top_head.insertBefore(anti_script, top_head.firstChild);
  
        document.dispatchEvent(new Event("DCBProtectRun"));
        document.addEventListener("gateway-load", (evt) => {
          console.log("Anti‑fraud gateway loaded:", evt);
        });
      }


//      if (scriptContent && scriptContent.trim() !== "") {
//   const script = document.createElement("script");

//   script.type = "text/javascript";

//   // 🔥 IMPORTANT: Use textContent (not innerHTML)
//   script.textContent = scriptContent;

//   document.head.appendChild(script);

//   console.log("Exact script injected into head");
// }









    } catch (error) {
      console.error("Error fetching script‑flow:", error);
      toast.error(`Could not load verification script.${error}`);
    } finally {
      setLoading(false);
    }
  };

  
    useEffect(() => {
   requestAnimationFrame(() => {
    getScript();
  });
}, []);







    const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };



  const handleAcceptBlock=()=>{
    console.log('onaccept called')
    setContentBlockDecision('Accepted')
    setOtpPage(true)
    //  navigate('/consent')
    setShowBlockModal(false);
  }

  const handleDeclineBlock=()=>{
    console.log('onreject called')
    setContentBlockDecision('Rejected')
    //  setShowBlockModal(false)
     handleOtpAfterContentBlock()

window.location.href = 'https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill';
  return;


    // setContentBlockDecision('Rejected')
    //     setShowBlockModal(false);
    //     // navigate('/consent')
    // setOtpPage(true)
    
  }




  // ─────────────── 3. Subscribe Handler ───────────────
  const handleSubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = { msisdn: msisdn?.trim(),
        // ti:uniqueIdRef.current 
         ti: extRef 
        
      };
      console.log(payload,'payload-------------------')
      localStorage.setItem("msisdn", msisdn);

      const { data } = await axios.post(`${baseUrlApi}${qualifyEndpoint}`, payload);
      console.log(data,'data from qualify------------------')

      if (data?.status == "success") {
        toast.success(data?.message);
        sessionStorage.setItem("packageId", data?.packageId);
        sessionStorage.setItem("sourceTransactionId", data?.sourceTransactionId);
        localStorage.setItem("ext_ref", extRef);

        setSourceTrxId(data?.sourceTransactionId)
        setPackageId(data?.packageId)

        setContentBlockStatus(data?.contentBlockStatus)

        if(data?.contentBlockStatus.toLowerCase() == 'y' || data?.contentBlockStatus.toLowerCase() == 'contentblock'){
          setShowBlockModal(true)
        }
        else{
           setOtpPage(true)
        }

        // navigate("/otp");
       
      } 
      // else if(data.code == '409'){
      //   toast.error(data.message);
      //   navigate('/home')
      // }
      else {
        // toast.error(data.message || "Something went wrong.");

        if(data.code == '423'){
          // if(data.message.includes('Restricted Customer Profile. Content Blocked.')){
          navigate('/block')
        //  }
        //  else{
        //   navigate('/')
        //  }
        }
        else if(data.code == '404'){
          toast.error(data.message);

        }
        else if(data.code == '409'){

          if(data.message.toLowerCase() == 'user already subscribed'){
            localStorage.setItem('msisdn',data?.subscriptionId)
            // navigate('/home')
          //  window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${data?.subscriptionId}`
          setLoading(true)
            toast.success('User Already Exists!!')
           navigate(`/home?msisdn=${data?.subscriptionId}`);
          //  toast.success('User Already Exists!!')
           setLoading(false)
          }
          else if(data.message.includes('Business Conflict:')){
            toast.error(data.message);
          }
          else if(data.message == 'SYSTEM_ERROR' || data.message.toLowerCase() == 'system error'){
            navigate('time-out')
          }
        //   if(data.message == 'Restricted Customer Profile. Content Blocked.'){
        //   navigate('/block')
        //  }

        //  else if(data.message == 'System error' || data.message == 'Session expired. Please start again.'){
        //   navigate('/time-out')
        //  }
        //  else{
        //   navigate('/')
        //  }
        }
        else if(data.code == '400'){
          //bad request
          toast.error(data.message)
        }
        else if(data.code == '429' || data.code == '401' || data.code == '403' || data.code == '500' || data.code == '429'){
          toast.error(data.message)
        }

         

        setMsisdn('')
      }
    } catch (err) {
      console.error("Qualify API failed:", err);
      // toast.error("Network error – please try again.");
      if(err.response.data.code == '423'){
          // if(data.message.includes('Restricted Customer Profile. Content Blocked.')){
          navigate('/block')
        //  }
        //  else{
        //   navigate('/')
        //  }
        }
        else if(err.response.data.code == '404'){
          toast.error(err.response.data.message);

        }
        else if(err.response.data.code == '409'){

          if(err.response.data.message.toLowerCase() == 'user already subscribed'){
            localStorage.setItem('msisdn',msisdn)
            // navigate('/home')
            // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`
            navigate(`/home?msisdn=${msisdn}`);

          }
          else if(err.response.data.message.includes('Business Conflict:')){
            toast.error(err.response.data.message);
          }
          else if(err.response.data.message == 'SYSTEM_ERROR' || err.response.data.message.toLowerCase() == 'system error'){
            navigate('time-out')
          }
        //   if(data.message == 'Restricted Customer Profile. Content Blocked.'){
        //   navigate('/block')
        //  }

        //  else if(data.message == 'System error' || data.message == 'Session expired. Please start again.'){
        //   navigate('/time-out')
        //  }
        //  else{
        //   navigate('/')
        //  }
        }
        else if(err.response.data.code == '400'){
          //bad request
          toast.error(err.response.data.message)
        }
        else if(err.response.data.code == '429' || err.response.data.code == '401' || err.response.data.code == '403' || err.response.data.code == '500' || err.response.data.code == '429'){
          toast.error(err.response.data.message)
        }
        else{
          navigate('/')
        }

      
    } finally {
      setLoading(false);
    }
  };

  // ─────────────── 4. Loader Display ───────────────
  if (loading) {
    return (
      <div className={classes.loaderWrapper}>
        <Lottie animationData={loaderAnimation} loop className={classes.loader} />
      </div>
    );
  }





   const handleOtpAfterContentBlock = async () => {
  // e.preventDefault();



  setVerifying(true); // 🟡 Start loader

  const enteredOtp = '2568'
  const msisdn = localStorage.getItem("msisdn");
  const packageId = sessionStorage.getItem("packageId");
  


  const tokenId = TVal;
  

  if (!msisdn || !packageId || !sourceTrxId || !tokenId) {
    toast.error("Session expired or missing data. Please start again.");
     setOtp(""); // clear all fields
     inputsRef.current[0]?.focus();
    setVerifying(false); // 🛑 Stop loader
    // navigate('/subscribe')
    return;
  }

  const payload = {
    msisdn,
    otp: enteredOtp,
    // tokenId:sourceTrxId,
    tokenId: extRef,
    sourceTransactionId:sourceTrxId,
    packageId,
    contentBlockDecision:'Rejected',
    contentBlockStatus
  };

  console.log(payload,'otp payload -----------------------------')

  try {
    const { data } = await axios.post(`${baseUrlApi}${verifyOtpEndpoint}`, payload);

    console.log("OTP verification response:", data);

//     if (data.status === "success") {
//       toast.success("OTP verified successfully!");
//       // navigate("/home", { state: data });
//       // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`

//       navigate(`/home?msisdn=${data?.subscriptionId}`);
//     }
//     else {
//   // toast.error(data.message || "OTP verification failed.");

//        if(data.code == 400){

//         if(data.message == 'Invalid OTP. Please enter the correct OTP.'){
//           toast.error(data.message)

//           setOtpPage(true);
//           setOtp("")
//           return;
//         }
//         else if(data.message == 'OTP expired. Press re-send OTP or start over again from MSISDN page.'){

//            toast.error(data.message)

//           //resend otp button (hit qualify)
//           showResend(true)
//           setOtpPage(true)
//           setOtp("")
//           return;

//         }
//         else if(data.message == 'Either press re-send OTP or start over again from MSISDN page.'){
//           toast.error(data.message)

          

//           // setOtpPage(false)
//           // setOtp(["", "", "", ""])

//           // setOtpPage(false)
//         }
//         else if(data.message.includes('Maximum retry limit exceeded. Locked for 24 hours')){
//           toast.error(data.message)
//           navigate('/time-out')
//         }

//         else{
//           toast.error(data.message)
//           navigate('/time-out')
//         }
        
//        }
//        else if(data.code == 409){
//          if(data.message.toLowerCase() == 'user already subscribed'){
//             localStorage.setItem('msisdn',msisdn)
//             // navigate('/home')
//           // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`
//           navigate(`/home?msisdn=${msisdn}`)
//           }
//           else if(data.message.includes('Business Conflict:')){
//             toast.error(data.message);
//             // navigate('/time-out')
//              toast.error('A system error occurred and we could not complete the transaction.')
//             navigate('/subscribe')
//           }
//           else if(data.message == 'SYSTEM_ERROR' || data.message.toLowerCase() == 'system_error' || data.message.toLowerCase().includes('system_error')){
//             // navigate('/time-out')
//              toast.error('A system error occurred and we could not complete the transaction.')
//             navigate('/subscribe')
//           }
//           else if(data.message == 'Fraud detected by EVINA or page compliance failed.'){
//             // toast.error(data.message)
//             // navigate('/time-out')
//              toast.error('A system error occurred and we could not complete the transaction.')
//             navigate('/subscribe')

//           }
//           else if(data.message.includes('Insufficient') || data.message.includes('Payment failed')){
//             navigate('/insufficient-funds')
//           }
         
//           else if(data.message == 'Business rule violation: system_error'){
//             // navigate('/time-out')
//              toast.error('A system error occurred and we could not complete the transaction.')
//              navigate('/subscribe')
//           }
//           else{

//           }
//        }
//        else if(data.code == '423'){
//           // if(data.message.includes('Restricted Customer Profile. Content Blocked.')){
//           navigate('/block')
//         //  }
//         //  else{
//         //   navigate('/')
//         //  }
//         }

//         else if(data.code == '429' || data.code == '500'){
//           //toast.error(data.message)
//           // navigate('/time-out')
//            toast.error('A system error occurred and we could not complete the transaction.')
//             navigate('/subscribe')
//         } 
//          else{
//           // navigate('/home')
//           // setOtp(["", "", "", ""])
//           setOtp("")
//           toast.error(data.message)
//          }




//   // setOtp(["", "", "", ""]); // clear all fields
//   setOtp("")
  
// //  setTimeout(()=>{

// //    navigate('/subscribe')
// //  },3000)
// // setRedirecting(true); // 🔶 Show loader
// requestAnimationFrame(() => {
//   setTimeout(() => {
//     // navigate("/subscribe");
//   }, 3000); // wait 3 seconds
// });

//   inputsRef.current[0]?.focus(); // focus back to first input
// }
    // } else {
    //   toast.error(data.message || "OTP verification failed.");
    // }
  } catch (err) {
    console.error("OTP verification failed:", err);
    // toast.error("Network error. Please try again.");


     if(err.response.data.code == '409'){
         toast.error(err.response.data.message);
         if(err.response.data.message.includes('Insufficient')){
          navigate('/insufficient-funds')
         }
         else if(err.response.data.message == 'System error' || err.response.data.message == 'Session expired. Please start again.'){
          // navigate('/time-out')
           toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
         }
         else if(err.response.data.message == 'Restricted Customer Profile. Content Blocked'){
          navigate('/block')
         }
         else{
          navigate('/')
         }

      }
//     setTimeout(()=>{

//    navigate('/subscribe')
//  },3000)
setRedirecting(true); // 🔶
requestAnimationFrame(() => {
  setTimeout(() => {
    navigate("/subscribe");
  }, 3000);})

  } finally {
    setVerifying(false); // 🛑 Stop loader
  }
};




  




      const handleOtpSubmit = async (e) => {
  e.preventDefault();

  if (otp.length !== 4) {
    toast.error("Please enter all 4 digits.");
    return;
  }

  setVerifying(true); // 🟡 Start loader

  const enteredOtp = otp
  const msisdn = localStorage.getItem("msisdn");
  const packageId = sessionStorage.getItem("packageId");
  
  const tokenId = TVal;
  

  if (!msisdn || !packageId || !sourceTrxId || !tokenId) {
    toast.error("Session expired or missing data. Please start again.");
     setOtp(""); // clear all fields
     inputsRef.current[0]?.focus();
    setVerifying(false); // 🛑 Stop loader
    // navigate('/subscribe')
    return;
  }

  const payload = {
    msisdn,
    otp: enteredOtp,
    tokenId:sourceTrxId,
    sourceTransactionId:sourceTrxId,
    packageId,
    contentBlockDecision,
    contentBlockStatus
  };

  console.log(payload,'otp payload -----------------------------')

  try {
    const { data } = await axios.post(`${baseUrlApi}${verifyOtpEndpoint}`, payload);

    console.log("OTP verification response:", data);

    if (data.status === "success") {
      toast.success("OTP verified successfully!");
      // navigate("/home", { state: data });
      // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`

      navigate(`/home?msisdn=${data?.subscriptionId}`);
    }
    else {
  // toast.error(data.message || "OTP verification failed.");

       if(data.code == 400){

        if(data.message == 'Invalid OTP. Please enter the correct OTP.'){
          toast.error(data.message)

          setOtpPage(true);
          setOtp("")
          return;
        }
        else if(data.message == 'OTP expired. Press re-send OTP or start over again from MSISDN page.'){

           toast.error(data.message)

          //resend otp button (hit qualify)
          showResend(true)
          setOtpPage(true)
          setOtp("")
          return;

        }
        else if(data.message == 'Either press re-send OTP or start over again from MSISDN page.'){
          toast.error(data.message)

          

          // setOtpPage(false)
          // setOtp(["", "", "", ""])

          // setOtpPage(false)
        }
        else if(data.message.includes('Maximum retry limit exceeded. Locked for 24 hours')){
          toast.error(data.message)
          navigate('/time-out')
        }

        else{
          toast.error(data.message)
          navigate('/time-out')
        }
        
       }
       else if(data.code == 409){
         if(data.message.toLowerCase() == 'user already subscribed'){
            localStorage.setItem('msisdn',msisdn)
            // navigate('/home')
          // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`
          navigate(`/home?msisdn=${msisdn}`)
          }
          else if(data.message.includes('Business Conflict:')){
            toast.error(data.message);
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
          }
          else if(data.message == 'SYSTEM_ERROR' || data.message.toLowerCase() == 'system_error' || data.message.toLowerCase().includes('system_error')){
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
          }
          else if(data.message == 'Fraud detected by EVINA or page compliance failed.'){
            // toast.error(data.message)
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')

          }
          else if(data.message.includes('Insufficient') || data.message.includes('Payment failed')){
            navigate('/insufficient-funds')
          }
         
          else if(data.message == 'Business rule violation: system_error'){
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
             navigate('/subscribe')
          }
          else{

          }
       }
       else if(data.code == '423'){
          // if(data.message.includes('Restricted Customer Profile. Content Blocked.')){
          navigate('/block')
        //  }
        //  else{
        //   navigate('/')
        //  }
        }

        else if(data.code == '429' || data.code == '500'){
          //toast.error(data.message)
          // navigate('/time-out')
           toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
        } 
         else{
          // navigate('/home')
          // setOtp(["", "", "", ""])
          setOtp("")
          toast.error(data.message)
         }




  // setOtp(["", "", "", ""]); // clear all fields
  setOtp("")
  
//  setTimeout(()=>{

//    navigate('/subscribe')
//  },3000)
// setRedirecting(true); // 🔶 Show loader
requestAnimationFrame(() => {
  setTimeout(() => {
    // navigate("/subscribe");
  }, 3000); // wait 3 seconds
});

  inputsRef.current[0]?.focus(); // focus back to first input
}
    // } else {
    //   toast.error(data.message || "OTP verification failed.");
    // }
  } catch (err) {
    console.error("OTP verification failed:", err);
    // toast.error("Network error. Please try again.");


     if(err.response.data.code == '409'){
         toast.error(err.response.data.message);
         if(err.response.data.message.includes('Insufficient')){
          navigate('/insufficient-funds')
         }
         else if(err.response.data.message == 'System error' || err.response.data.message == 'Session expired. Please start again.'){
          // navigate('/time-out')
           toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
         }
         else if(err.response.data.message == 'Restricted Customer Profile. Content Blocked'){
          navigate('/block')
         }
         else{
          navigate('/')
         }

      }
//     setTimeout(()=>{

//    navigate('/subscribe')
//  },3000)
setRedirecting(true); // 🔶
requestAnimationFrame(() => {
  setTimeout(() => {
    navigate("/subscribe");
  }, 3000);})

  } finally {
    setVerifying(false); // 🛑 Stop loader
  }
};





    const handleOtpSubmitWhenCancel = async () => {
  // e.preventDefault();

  // if (otp.length !== 4) {
  //   toast.error("Please enter all 4 digits.");
  //   return;
  // }

  setVerifying(true); // 🟡 Start loader

  const enteredOtp = otp
  const msisdn = localStorage.getItem("msisdn");
  const packageId = sessionStorage.getItem("packageId");
  
  const tokenId = TVal;
  

  // if (!msisdn || !packageId || !sourceTrxId || !tokenId) {
  //   toast.error("Session expired or missing data. Please start again.");
  //    setOtp(""); // clear all fields
  //    inputsRef.current[0]?.focus();
  //   setVerifying(false); // 🛑 Stop loader
  //   // navigate('/subscribe')
  //   return;
  // }

  const payload = {
    msisdn,
    otp: enteredOtp,
    tokenId:sourceTrxId,
    sourceTransactionId:sourceTrxId,
    packageId,
    contentBlockDecision:'Rejected',
    contentBlockStatus
  };

  console.log(payload,'otp payload -----------------------------')

  try {
    const { data } = await axios.post(`${baseUrlApi}${otpAfterDecline}`, payload);

    console.log("OTP verification response:", data);

    if (data.status === "success") {
      toast.success("OTP verified successfully!");
      // navigate("/home", { state: data });
      // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`

      navigate(`/home?msisdn=${data?.subscriptionId}`);
    }
    else {
  // toast.error(data.message || "OTP verification failed.");

       if(data.code == 400){

        if(data.message == 'Invalid OTP. Please enter the correct OTP.'){
          toast.error(data.message)

          setOtpPage(true);
          setOtp("")
          return;
        }
        else if(data.message == 'OTP expired. Press re-send OTP or start over again from MSISDN page.'){

           toast.error(data.message)

          //resend otp button (hit qualify)
          showResend(true)
          setOtpPage(true)
          setOtp("")
          return;

        }
        else if(data.message == 'Either press re-send OTP or start over again from MSISDN page.'){
          toast.error(data.message)

          

          // setOtpPage(false)
          // setOtp(["", "", "", ""])

          // setOtpPage(false)
        }
        else if(data.message.includes('Maximum retry limit exceeded. Locked for 24 hours')){
          toast.error(data.message)
          navigate('/time-out')
        }

        else{
          toast.error(data.message)
          navigate('/time-out')
        }
        
       }
       else if(data.code == 409){
         if(data.message.toLowerCase() == 'user already subscribed'){
            localStorage.setItem('msisdn',msisdn)
            // navigate('/home')
          // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`
          navigate(`/home?msisdn=${msisdn}`)
          }
          else if(data.message.includes('Business Conflict:')){
            toast.error(data.message);
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
          }
          else if(data.message == 'SYSTEM_ERROR' || data.message.toLowerCase() == 'system_error' || data.message.toLowerCase().includes('system_error')){
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
          }
          else if(data.message == 'Fraud detected by EVINA or page compliance failed.'){
            // toast.error(data.message)
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')

          }
          else if(data.message.includes('Insufficient') || data.message.includes('Payment failed')){
            navigate('/insufficient-funds')
          }
         
          else if(data.message == 'Business rule violation: system_error'){
            // navigate('/time-out')
             toast.error('A system error occurred and we could not complete the transaction.')
             navigate('/subscribe')
          }
          else{

          }
       }
       else if(data.code == '423'){
          // if(data.message.includes('Restricted Customer Profile. Content Blocked.')){
          navigate('/block')
        //  }
        //  else{
        //   navigate('/')
        //  }
        }

        else if(data.code == '429' || data.code == '500'){
          //toast.error(data.message)
          // navigate('/time-out')
           toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
        } 
         else{
          // navigate('/home')
          // setOtp(["", "", "", ""])
          setOtp("")
          toast.error(data.message)
         }




  // setOtp(["", "", "", ""]); // clear all fields
  setOtp("")
  
//  setTimeout(()=>{

//    navigate('/subscribe')
//  },3000)
// setRedirecting(true); // 🔶 Show loader
requestAnimationFrame(() => {
  setTimeout(() => {
    // navigate("/subscribe");
  }, 3000); // wait 3 seconds
});

  inputsRef.current[0]?.focus(); // focus back to first input
}
    // } else {
    //   toast.error(data.message || "OTP verification failed.");
    // }
  } catch (err) {
    console.error("OTP verification failed:", err);
    // toast.error("Network error. Please try again.");


     if(err.response.data.code == '409'){
         toast.error(err.response.data.message);
         if(err.response.data.message.includes('Insufficient')){
          navigate('/insufficient-funds')
         }
         else if(err.response.data.message == 'System error' || err.response.data.message == 'Session expired. Please start again.'){
          // navigate('/time-out')
           toast.error('A system error occurred and we could not complete the transaction.')
            navigate('/subscribe')
         }
         else if(err.response.data.message == 'Restricted Customer Profile. Content Blocked'){
          navigate('/block')
         }
         else{
          navigate('/')
         }

      }
//     setTimeout(()=>{

//    navigate('/subscribe')
//  },3000)
setRedirecting(true); // 🔶
requestAnimationFrame(() => {
  setTimeout(() => {
    navigate("/subscribe");
  }, 3000);})

  } finally {
    setVerifying(false); // 🛑 Stop loader
  }
};






const handleExit=()=>{
  window.location.href= 'https://www.google.com/'
}

const handleResendOtp = (e)=>{
  e.preventDefault()
   console.log('resend Otp called')
   handleSubscribe(e);
}


const handleOtpDecline = ()=>{
  // setOtpPage(false)
    // handleOtpDecline()
    handleOtpSubmitWhenCancel()

// window.location.href = 'https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill';
  window.location.href = 'https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill';
  return;
}



  
  return (
  <div className={`cptpl_page ${classes.wrapper}`}>
   <input type="hidden" value="20221206" name="cptpl_template" class="cptpl_template"/>
   {/* <input type="hidden" value="20251023" name="cptpl_template" class="test cptpl_template" />  */}

   <input type="hidden" value="" name="cptpl_landing_page_id" class="test  cptpl_landing_page_id  " />

  <div className={classes.card}>
    <div className={classes.logoHeading}>
      <img src="https://vd-kickwin.gameit.in/assets/images/soccer-ball.png" alt="Logo" className={`cptpl_logo cptpl_logo_static ${classes.logo}`}
     crossorigin="anonymous" />
      <h3 className={`cptpl_service ${classes.heading}`}>Kick n Winn</h3>
    </div>

   {
    !otpPage ?
    //  <p className={classes.subtext}>

    //   {/* <strong>User must enter cell number</strong><br /> */}
    //   {/* Get FREE for 1 day then */}
    //   {/* Access the Service for Only */}
    //   Get Endless Sports Insights with Kick n Winn
    //   <span className="cptpl_price" > R9/Day</span><br />
    //   <span className="cptpl_account" >On Your Vodacom Account</span><br />
    //   <span className="cptpl_bill" >Pay with Vodacom Add To Bill</span>
      
    // </p>

     <p className={classes.subtext}>
  Get Endless Sports Insights with Kick n Winn
  <br />
  <span className="cptpl_price">Enjoy Your First-Day Free Trial at R7/Day After Trial</span>
  <br />
  <span className="cptpl_account">On Your Vodacom Account</span>
  <br />
  <span className="cptpl_bill">Pay with Vodacom Add To Bill</span>
</p>

    :
    <>
         <h2 className={classes.heading}>Enter Your 4-digit OTP</h2> 

          <p className={classes.subtext}>
      {/* <strong>Enter your mobile number</strong><br /> */}
      {/* Get FREE for 1 day then */}
      {/* Access the Service for Only */}
  Get Endless Sports Insights with Kick n Winn
      <span className="cptpl_price" >Enjoy Your First-Day Free Trial! Just R9/Day
</span><br />
      <span className="cptpl_account" >On Your Vodacom Account</span><br />
      <span className="cptpl_bill" >Pay with Vodacom Add To Bill</span>
      
    </p>
        
        <p className={classes.message}>
        To confirm this charge on your vodacom account,please enter the One-Time PIN (OTP) sent to your Phone number below to continue:
        </p>
    </>
   }
          

    {
        !otpPage ?
        <form onSubmit={handleSubscribe} className={classes.form}>
                    <Link className={` cptpl_terms ${classes.terms}`}>Terms & Conditions</Link>

        {/* <Link to='/terms' className={` cptpl_terms ${classes.terms}`}>Terms & Conditions</Link> */}
<br/><br/>
      <input
        type="tel"
        // type="hidden"
        placeholder="27123456789"
        value={msisdn}
        onChange={(e) => setMsisdn(e.target.value)}
        required
        className={`${classes.input}`}
        // style={{width:'30%'}}
      />
      <small style={{ color: "#eee", fontSize: "1rem" }}>
        Please include area code: (e.g., 27123456789)
      </small>
      <br/>

      
      <div className={classes.btns}>
        <button type="submit"  className={` cptpl_subscribe ${classes.subbutton}`} >
        SUBMIT
      </button>
      <button type="button" className={`protected cptpl_exit ${classes.extbutton}`}   onClick={handleExit}>
        EXIT
      </button>
      </div>

      
    </form>
    :
    <>
         <form onSubmit={handleOtpSubmit} className={classes.otpForm}>
          <div className={classes.otpBoxes}>
            {/*otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength="1"
                value={digit}
                ref={(el) => (inputsRef.current[index] = el)}
                className={classes.otpInput}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                required
              />
            ))*/}




            <input
              type="text"
              // type="hidden"
              placeholder="Enter Your 4-digit OTP"
              value={otp}
               maxLength={4}
              onChange={(e) => setOtp(e.target.value)}
              required
              className={`${classes.input_otp}`}
            />


          </div>
          {/* <button type="submit" className={classes.submitBtn} id="cta_button">
            Verify
          </button> */}
        <div className={classes.btns}>
          {/* {
            showResend ? */}
             <>
                      <div
  // type="submit"
  className={`protected  ${classes.resend}`}
  // id="cta_button"
 // disabled={verifying || loading} // ⛔ prevent double clicks
  onClick={handleResendOtp}
>
  RESEND OTP
</div>
            </>
            {/* : */}
            <>

            <span>Click 'Accept' to agree and get access to Kick n Winn!</span>
      <span>Get Endless Sports Insights with Kick n Winn R9/Day on your Vodacom Account. </span>
     <span>
          <Link className={`cptpl_terms ${classes.terms}`}>

  {/* <Link to="/terms" className={`cptpl_terms ${classes.terms}`}> */}
    Terms & Conditions
  </Link>
  &nbsp;apply
</span>
<br/><br/>


                <button
  type="submit"
  className={`protected cptpl_subscribe ${classes.submitBtn}`}
  // id="cta_button"
  disabled={verifying || loading} // ⛔ prevent double clicks
>
  {verifying ? "ACCEPTING..." : "ACCEPT"}
</button>
            </>
          {/* } */}

 <button type="button" className={`protected cptpl_exit ${classes.extbutton}`}   onClick={handleOtpDecline}>
        DECLINE
      </button>
        </div>


        </form>
    </>
    }
  </div>

  {
          showBlockModal && (
         

            <BlockModalFree
          onAccept={handleAcceptBlock}
            onDecline={handleDeclineBlock}
        />
          )
        }
</div>

  );
};

export default SubscribePageFree;
